import { Bill, DisplayBillState } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Tag, TagVariant } from '@optimus-web/core';

type BillStateTagMap = Record<
    DisplayBillState,
    {
        textKey: Mews.TextKey;
        tagVariant: TagVariant;
    }
>;

const billStateTagTextKeyMap: BillStateTagMap = {
    [DisplayBillState.Closed]: { textKey: TextKey.Closed, tagVariant: 'basicBold' },
    [DisplayBillState.Open]: { textKey: TextKey.Open, tagVariant: 'basicBold' },
    [DisplayBillState.Overdue]: { textKey: TextKey.Overdue, tagVariant: 'warning' },
    [DisplayBillState.Paid]: { textKey: TextKey.Paid, tagVariant: 'success' },
    [DisplayBillState.Unpaid]: { textKey: TextKey.Unpaid, tagVariant: 'primary' },
    [DisplayBillState.PartiallyPaid]: { textKey: TextKey.PartiallyPaid, tagVariant: 'basicBold' },
    [DisplayBillState.ProcessingPayment]: { textKey: TextKey.Processing, tagVariant: 'lavender' },
};

interface BillStateProps {
    bill: Bill;
}

const BillStateTag = ({ bill }: BillStateProps) => {
    const { textKey, tagVariant } = billStateTagTextKeyMap[bill.displayState];

    return (
        <Tag variant={tagVariant}>
            <LocalizedText textKey={textKey} />
        </Tag>
    );
};

export default BillStateTag;
